import { Day } from "./Day";
import { Month } from "./Month";
import { Year } from "./Year";

export * from "./Day";
export * from "./Month";
export * from "./Year";

export const Date = {
  Day,
  Month,
  Year,
};
